<template>
	<div id="app">
		<div id="nav">
			<!-- <router-link to="/">Home</router-link> -->
			<!-- <HomeIndex></HomeIndex> -->
			<router-view />
		</div>
	</div>
</template>
<script>
	export default {
		name: "App",
		data: {
			
	    },
		
		methods:{
		},
		beforeCreate() {
		},
		created() {
			
		},
		components: {
			// HomeIndex
		},
		computed: {
			
		}
	}
</script>

<style>
	@font-face {
	  font-family: 'iconfont';  /* project id 2315885 */
	  src: url('//at.alicdn.com/t/font_2315885_f9czmvjcxze.eot');
	  src: url('//at.alicdn.com/t/font_2315885_f9czmvjcxze.eot?#iefix') format('embedded-opentype'),
	  url('//at.alicdn.com/t/font_2315885_f9czmvjcxze.woff2') format('woff2'),
	  url('//at.alicdn.com/t/font_2315885_f9czmvjcxze.woff') format('woff'),
	  url('//at.alicdn.com/t/font_2315885_f9czmvjcxze.ttf') format('truetype'),
	  url('//at.alicdn.com/t/font_2315885_f9czmvjcxze.svg#iconfont') format('svg');
	}
	#app{
		font-size: 1rem;
	}
</style>
